import { WorkspaceItem } from '@/Workspaces/Workspace'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

const workspaceSearchSchema = z.object({
  page: z.number().optional().catch(1),
})

export const Route = createFileRoute('/workspace/$workspaceId/')({
  component: () => <WorkspaceItem />,
  validateSearch: (search) => workspaceSearchSchema.parse(search),
})